import { Box, Skeleton, Typography } from '@mui/material';
import { Fragment } from 'react';

export const ResourceInfoSkeleton = () => {
  return (
    <Box sx={{ display: 'grid', gridTemplateRows: 'auto', gridTemplateColumns: '1fr 2fr', rowGap: { xs: 1, md: 2 }, columnGap: 2 }}>
      {Array.from({ length: 4 }).map((_, index) => (
        <Fragment key={index}>
          <Typography variant="body1" sx={{ fontWeight: 600, gridRow: `${index + 1}`, gridColumn: '1 / 1', whiteSpace: 'nowrap' }}>
            <Skeleton width="100%" variant="rectangular" />
          </Typography>
          <Typography sx={{ gridRow: `${index + 1}`, gridColumn: '2 / 2' }}>
            <Skeleton width="100%" variant="rectangular" />
          </Typography>
        </Fragment>
      ))}
    </Box>
  );
};
